var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionAnswerFill = function SvgQuestionAnswerFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.4 17.4h9.213l1.587 1.247V9.3h.9a.9.9 0 0 1 .9.9v12.15l-4.01-3.15H9.3a.9.9 0 0 1-.9-.9zm-2.29-1.8L2.1 18.75V4.8a.9.9 0 0 1 .9-.9h13.5a.9.9 0 0 1 .9.9v10.8z"
  })));
};
export default SvgQuestionAnswerFill;